import firebase from 'firebase'
import 'firebase/firestore'

const config =  

//  {
//     apiKey: "AIzaSyDC-c8qL32mwr_w0ATAWRAPvxMJ2PId27s",
//     authDomain: "xmooc-92ae4.firebaseapp.com",
//     databaseURL: "https://xmooc-92ae4.firebaseio.com",
//     projectId: "xmooc-92ae4",
//     storageBucket: "xmooc-92ae4.appspot.com",
//     messagingSenderId: "43781761253",
//     appId: "1:43781761253:web:450f3bd00289a1c5b68c0c",
//     measurementId: "G-DGB1V9Z5NL"
// };
 
// {
//     apiKey: "AIzaSyBOGNuCtvCP_UZg1fOAZb5zE4ElWtkfHi0",
//     authDomain: "myic-d5bde.firebaseapp.com",
//     databaseURL: "https://myic-d5bde.firebaseio.com",
//     projectId: "myic-d5bde",
//     storageBucket: "myic-d5bde.appspot.com",
//     messagingSenderId: "292272376182",
//     appId: "1:292272376182:web:90c8ca5187eb484b93d257",
//     measurementId: "G-CHRSJT6W9B"
//   };
 {
  apiKey: "AIzaSyDEYgHnsk4kKoRnPDBThk5vwdk7GXCm_Qg",
  authDomain: "muis-29e1f.firebaseapp.com",
  databaseURL: "https://muis-29e1f.firebaseio.com",
  projectId: "muis-29e1f",
  storageBucket: "muis-29e1f.appspot.com",
  messagingSenderId: "266535950585",
  appId: "1:266535950585:web:bf0d28cc2ec36c963daa28",
  measurementId: "G-QPV5EMZ0ZE"
};

// {
//   apiKey: "AIzaSyBx-b8WtpfUcaRtDhb-Jpall4bZc5CSlag",
//   authDomain: "gradedu-855be.firebaseapp.com",
//   databaseURL: "https://gradedu-855be.firebaseio.com",
//   projectId: "gradedu-855be",
//   storageBucket: "gradedu-855be.appspot.com",
//   messagingSenderId: "304161541159",
//   appId: "1:304161541159:web:317389d0dc1deb59ba5202",
//   measurementId: "G-JQKCYLJDLR"
// };
 
 
firebase.initializeApp(config)
// firebase utils
const firestore=firebase.firestore
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
var googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.addScope("email");
const usersCollection= db.collection("users")
const storage = firebase.storage;
const storageRef = firebase.storage().ref();

const APPNAME = "MNU Online";
const SHOWLOGO = true;
const LOGOPATH="/assets/img/logo.png";
const SHOW_GRAD_FORM=false;

// const APPNAME = "Gradedu Online";
// const SHOWLOGO = false;
// const LOGOPATH=null;
// const SHOW_GRAD_FORM=true;

export {
    db,
    auth,
    currentUser,
    googleProvider, 
    usersCollection,
    storage,
    storageRef,
    firestore,
    APPNAME,
    SHOWLOGO,
    LOGOPATH,
    SHOW_GRAD_FORM

}